// Full-document render of the Oscar address create/update views:
// PageSkeleton wrapping the tempurpedic breadcrumb shell ("Your
// Account / Your Addresses / Your Address Book") and the UserAddressForm
// rendered as a native React field tree.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { AccountForm } from "../components/AccountForm";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressFormDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: t`Your Account`, href: props.profile_url },
                { label: t`Your Addresses`, href: props.address_list_url },
                { label: t`Your Address Book` },
            ]}
            heading={t`Your Address Book`}
        >
            <AccountForm
                form_id={props.form_id}
                action_url={props.action_url}
                fields={props.fields}
                field_labels={props.field_labels}
                field_errors={props.field_errors}
                non_field_errors={props.non_field_errors}
                submit_text={props.submit_text}
                cancel_text={props.cancel_text}
            />
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
